import {Pipe, PipeTransform} from '@angular/core';
import {ValueFromAdditionalMapPipe} from './value-from-additional-map.pipe';
import {ServerConstants} from '../model/ServerConstants';
import {TopLevelDomainVO} from '../generate/TopLevelDomainVO';

@Pipe({
  name: 'pendingRequestIdExtractor'
})
export class PendingRequestIdExtractorPipe implements PipeTransform {
  constructor() {
  }

  transform(domain: TopLevelDomainVO, editChangeRequestMode: boolean, requestID: string, field: string): string {
    const valuesFromMap: ValueFromAdditionalMapPipe = new ValueFromAdditionalMapPipe();
    let pendingRequestId: any = valuesFromMap.transform(domain, ServerConstants.LOCK_FIELD_NAME, field);

    if (!editChangeRequestMode) {
      return pendingRequestId.length > 0 ? pendingRequestId.join() : '';
    } else {
      let editRequestBlockedSections = [ServerConstants.AUTH_POLICY_FIELD_NAME, ServerConstants.NAME_SERVERS_FIELD_NAME, ServerConstants.TRUST_ANCHORS_FIELD_NAME];
      if (pendingRequestId.indexOf(requestID) === -1 || editRequestBlockedSections.includes(field)) {
        return 'XXXXXX'; // returning some value to fill pendingrequest id - hack for edit change request mode
      } else {
        return '';
      }
    }
  }

}
